import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';

type AmenityItem = { name: string };
type AmenityTab = { key: string; label: string; items: string[] };

@Component({
  selector: 'app-hotel-amenities-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatTabsModule],
  templateUrl: './hotel-amenities-dialog.component.html',
  styleUrls: ['./hotel-amenities-dialog.component.scss'],
})
export class HotelAmenitiesDialogComponent implements OnInit {
  tabs: AmenityTab[] = [];

  constructor(
    private dialogRef: MatDialogRef<HotelAmenitiesDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      hotelAmenitiesInfo: AmenityItem[];
      roomAmenitiesInfo: AmenityItem[];
      roomTypes: string[];
    }
  ) {}

  ngOnInit(): void {
    this.tabs = [
      {
        key: 'property',
        label: 'Property amenities',
        items: (this.data?.hotelAmenitiesInfo || []).map((item) => item?.name).filter(Boolean),
      },
      {
        key: 'features',
        label: 'Room features',
        items: (this.data?.roomAmenitiesInfo || []).map((item) => item?.name).filter(Boolean),
      },
      {
        key: 'types',
        label: 'Room types',
        items: (this.data?.roomTypes || []).filter(Boolean),
      },
    ];
  }

  close() {
    this.dialogRef.close();
  }
}